/* ==========================================================================
   Rook Components — Portal
   Web Component: <rk-portal>
   Hidratação 'eager' — move os filhos pro <body> assim que conecta.

   Move os elementos filhos para o final do <body> para que overlays
   position:fixed (rk-dialog, etc.) escapem de stacking/overflow contexts de
   ancestrais (ex.: a seção product-information) e fiquem acima de tudo.

   Triggers externos (data-dialog-open) seguem funcionando: o rk-dialog wireia
   os gatilhos no nível do document, independente de onde o dialog está.
   ========================================================================== */

import { RkComponent } from '@rook/component';

class RkPortal extends RkComponent {
  static hydration = 'eager';

  /** @type {Element[]} */
  #moved = [];

  setup() {
    // Evita re-mover em reconexões (o próprio appendChild dispara reconnect).
    if (this.dataset.portaled === 'true') return;
    this.dataset.portaled = 'true';

    this.#moved = Array.from(this.children);
    this.#moved.forEach((child) => document.body.appendChild(child));
  }

  teardown() {
    // Devolve os nós pro próprio placeholder em vez de removê-los. Em
    // re-render do editor o placeholder é descartado junto, então não sobra
    // órfão no <body> — e se o placeholder só foi re-parenteado (reordenação
    // de blocos), o conteúdo volta com ele e é portado de novo no reconnect.
    this.#moved.forEach((child) => this.appendChild(child));
    this.#moved = [];
    delete this.dataset.portaled;
  }
}

if (!customElements.get('rk-portal')) {
  customElements.define('rk-portal', RkPortal);
}
